import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, Users, ArrowRight, BookOpen, Award } from 'lucide-react';

const UpcomingScroller = () => {
  const [search, setSearch] = useState('');
  const scrollerRef = useRef(null);

  const conferences = [
    { id: '218', name: '15th International Conference on Recent Challenges in Engineering and Technology', date: 'Sep 15-17, 2024', venue: 'Chennai, India' },
    { id: '219', name: 'International Conference on Advanced Research in Science & Technology 2024', date: 'Oct 10-12, 2024', venue: 'Bangalore, India' },
    { id: '220', name: 'Global Symposium on Sustainable Technologies', date: 'Nov 5-7, 2024', venue: 'Delhi, India' }
  ];

  const filtered = conferences.filter(c => c.name.toLowerCase().includes(search.toLowerCase()));

  const handleNext = () => {
    if (scrollerRef.current) {
      scrollerRef.current.scrollBy({ left: 320, behavior: 'smooth' });
    }
  };

  return (
    <div style={{ backgroundColor: 'white', padding: '18px', borderRadius: '12px', border: '1px solid #e6eefc' }}>
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '12px' }}>
        <input
          placeholder="Search upcoming conferences"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ flex: 1, padding: '10px 12px', borderRadius: '8px', border: '1px solid #e2e8f0' }}
        />
        <button onClick={handleNext} style={{ padding: '10px 14px', borderRadius: '8px', background: '#667eea', color: 'white', border: 'none', cursor: 'pointer' }}>Next</button>
      </div>

      <div ref={scrollerRef} style={{ display: 'flex', gap: '12px', overflowX: 'auto', paddingBottom: '6px' }}>
        {filtered.map(conf => (
          <Link key={conf.id} to={`/conference/upcoming?id=${conf.id}`} style={{ textDecoration: 'none', minWidth: '300px' }}>
            <div style={{ padding: '18px', borderRadius: '10px', background: 'linear-gradient(135deg, #f7fbff, #eef6ff)', border: '1px solid #e2e8f0' }}>
              <h4 style={{ margin: 0, color: '#2d3748', fontSize: '1rem', fontWeight: 700 }}>{conf.name}</h4>
              <p style={{ margin: '8px 0 0', color: '#718096', fontSize: '0.95rem' }}>{conf.date} • {conf.venue}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

const Conference = () => {
  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Hero Section */}
      <section className="hero-section text-center" style={{ 
        background: 'linear-gradient(135deg, rgba(30, 64, 175, 0.9), rgba(59, 130, 246, 0.9)), url("https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="container-custom">
          <h1 className="heading-1 text-white mb-6">International Conferences</h1>
          <p className="body-large text-white mb-8" style={{ maxWidth: '600px', margin: '0 auto 2rem', opacity: 0.95 }}>
            Join our international conferences and connect with leading researchers worldwide
          </p>
        </div>
      </section>

      <div className="container-custom" style={{ padding: '40px 24px' }}>
        {/* Upcoming horizontal scroller with search + next */}
        <UpcomingScroller />

        <div style={{ height: '40px' }} />

      </div>

      <div className="container-custom" style={{ padding: '40px 24px' }}>
        {/* Conference Categories */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
          gap: '40px',
          marginBottom: '80px'
        }}>
          {/* Upcoming Conference */}
          <Link to="/conference/upcoming" style={{ textDecoration: 'none' }}>
            <div style={{ 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
              padding: '3px', 
              borderRadius: '20px', 
              boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)',
              transition: 'transform 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
              <div style={{ 
                backgroundColor: 'white', 
                padding: '50px', 
                borderRadius: '17px',
                textAlign: 'center'
              }}>
                <div style={{ 
                  width: '100px', 
                  height: '100px', 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 30px',
                  fontSize: '3rem'
                }}>
                  🚀
                </div>
                <h3 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '20px' }}>
                  Upcoming Conference
                </h3>
                <p style={{ color: '#718096', fontSize: '1.1rem', lineHeight: '1.6' }}>
                  Join our next international conference featuring cutting-edge research presentations, keynote speakers, and networking opportunities.
                </p>
                <div style={{ 
                  marginTop: '30px',
                  padding: '15px 30px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  borderRadius: '25px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontWeight: 600
                }}>
                  View Details <ArrowRight size={20} />
                </div>
              </div>
            </div>
          </Link>

          {/* Past Conferences */}
          <Link to="/conference/past" style={{ textDecoration: 'none' }}>
            <div style={{ 
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', 
              padding: '3px', 
              borderRadius: '20px', 
              boxShadow: '0 8px 32px rgba(240, 147, 251, 0.3)',
              transition: 'transform 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
              <div style={{ 
                backgroundColor: 'white', 
                padding: '50px', 
                borderRadius: '17px',
                textAlign: 'center'
              }}>
                <div style={{ 
                  width: '100px', 
                  height: '100px', 
                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 30px',
                  fontSize: '3rem'
                }}>
                  📚
                </div>
                <h3 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '20px' }}>
                  Past Conferences
                </h3>
                <p style={{ color: '#718096', fontSize: '1.1rem', lineHeight: '1.6' }}>
                  Explore our archive of successful conferences, proceedings, research presentations, and memorable moments from previous years.
                </p>
                <div style={{ 
                  marginTop: '30px',
                  padding: '15px 30px',
                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                  color: 'white',
                  borderRadius: '25px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontWeight: 600
                }}>
                  View Archive <ArrowRight size={20} />
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* Conference Statistics */}
        <div style={{ 
          background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', 
          padding: '3px', 
          borderRadius: '20px', 
          boxShadow: '0 8px 32px rgba(79, 172, 254, 0.3)' 
        }}>
          <div style={{ 
            backgroundColor: 'white', 
            padding: '60px', 
            borderRadius: '17px'
          }}>
            <h2 style={{ textAlign: 'center', marginBottom: '50px', color: '#2d3748', fontSize: '2.5rem', fontWeight: 700 }}>
              Conference Impact
            </h2>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: '40px',
              textAlign: 'center'
            }}>
              <div>
                <div style={{ 
                  width: '80px', 
                  height: '80px', 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '2rem'
                }}>
                  👥
                </div>
                <div style={{ fontSize: '3rem', fontWeight: 700, color: '#667eea', marginBottom: '10px' }}>
                  1200+
                </div>
                <p style={{ color: '#718096', fontSize: '1.1rem', fontWeight: 600 }}>Total Participants</p>
              </div>
              
              <div>
                <div style={{ 
                  width: '80px', 
                  height: '80px', 
                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '2rem'
                }}>
                  📄
                </div>
                <div style={{ fontSize: '3rem', fontWeight: 700, color: '#f5576c', marginBottom: '10px' }}>
                  350+
                </div>
                <p style={{ color: '#718096', fontSize: '1.1rem', fontWeight: 600 }}>Research Papers</p>
              </div>
              
              <div>
                <div style={{ 
                  width: '80px', 
                  height: '80px', 
                  background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '2rem'
                }}>
                  🌍
                </div>
                <div style={{ fontSize: '3rem', fontWeight: 700, color: '#4facfe', marginBottom: '10px' }}>
                  25+
                </div>
                <p style={{ color: '#718096', fontSize: '1.1rem', fontWeight: 600 }}>Countries</p>
              </div>
              
              <div>
                <div style={{ 
                  width: '80px', 
                  height: '80px', 
                  background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '2rem'
                }}>
                  🏆
                </div>
                <div style={{ fontSize: '3rem', fontWeight: 700, color: '#38b2ac', marginBottom: '10px' }}>
                  5
                </div>
                <p style={{ color: '#718096', fontSize: '1.1rem', fontWeight: 600 }}>Years Running</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Conference;